import * as React from "react";

const DEFAULT_MOBILE_BREAKPOINT = 768;

export function useIsMobile(mobileBreakpoint = DEFAULT_MOBILE_BREAKPOINT) {
  // Initialise synchronously from the real viewport so the very first paint is
  // correct. The old `undefined` initial value resolved to `false` on mount,
  // which briefly rendered the desktop layout (and gated the mobile nav trigger
  // off) before the effect corrected it — a flash that could leave the menu
  // unreachable on slower devices / native webviews.
  const [isMobile, setIsMobile] = React.useState<boolean>(() =>
    typeof window !== "undefined" ? window.innerWidth < mobileBreakpoint : false,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${mobileBreakpoint - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < mobileBreakpoint);
    };
    mql.addEventListener("change", onChange);
    setIsMobile(window.innerWidth < mobileBreakpoint);
    return () => mql.removeEventListener("change", onChange);
  }, [mobileBreakpoint]);

  return isMobile;
}
